var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { IdStatusClientGateway } from "../client-gateway/IdStatusClientGateway";
import { TypeActionEnvSelect } from "./actionEnvSelect";
var initial = {
    environment: IdStatusClientGateway.Integration,
};
export var reducerEnvSelect = function (state, action) {
    if (state === void 0) { state = initial; }
    if (action.type === TypeActionEnvSelect.Select && action.environment) {
        return __assign({}, state, { environment: action.environment });
    }
    return __assign({}, state);
};



//////////////////
// WEBPACK FOOTER
// ./src/features/env-select/reducerEnvSelect.ts
// module id = 2526
// module chunks = 3